import React from 'react';
import { FilledButtonStyle } from '../../styles/common.style';
import type { SpotifyProfileIdentity } from '../../utils/spotifyAuth';
import { SpotifyReconnectModalStyle } from './SpotifyReconnectModal.style';

type SpotifyReconnectModalProps = {
  visible: boolean;
  identity?: SpotifyProfileIdentity | null;
  onCancel: () => void;
  onConfirm: () => void;
};

/**
 * Songplace-styled reconnect confirmation.
 * Positioned near the top of the viewport; actions in a single right-aligned row.
 */
const SpotifyReconnectModal: React.FC<SpotifyReconnectModalProps> = ({
  visible,
  identity,
  onCancel,
  onConfirm,
}) => {
  const profileName = identity?.username || 'this Spotify profile';

  return (
    <SpotifyReconnectModalStyle
      visible={visible}
      footer={null}
      onCancel={onCancel}
      destroyOnClose
      width={480}
      maskClosable={false}
      zIndex={1200}
      getContainer={() => document.body}
      centered={false}
      style={{ top: '12vh' }}
    >
      <h1 className="heading">Reconnect {profileName}</h1>

      <p className="body-text">
        Spotify will use the account currently logged into this browser. Make sure it is{' '}
        <strong>{profileName}</strong>. A different account will not update this profile.
      </p>

      <p className="body-text">
        <strong>Note:</strong> Some schedulers may have failed because your Spotify account required
        reauthorization. After reconnecting your account, please reset any affected schedulers to
        ensure they run correctly.
      </p>

      <div className="footer-actions">
        <FilledButtonStyle
          type="button"
          className="btn-cancel"
          onClick={onCancel}
          background="transparent"
          width="96px"
        >
          Cancel
        </FilledButtonStyle>
        <FilledButtonStyle
          type="button"
          className="btn-confirm"
          onClick={onConfirm}
          width="96px"
        >
          Okay
        </FilledButtonStyle>
      </div>
    </SpotifyReconnectModalStyle>
  );
};

export default SpotifyReconnectModal;
